module.exports = __webpack_public_path__ + "img/payme_with_hsbc.efaceb47.svg";